import {inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {filter, map, Observable, switchMap, tap} from 'rxjs';
import {Store} from '@ngrx/store';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {SnackBarActions} from '@store/aviary/aviary.adapter';
import {PATH_FOR} from '@app/app.routes';
import {AuthService} from '@aviary/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);
  private readonly store = inject(Store);

  public canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(PatronSelectors.Auth.finishedLoading).pipe(
      filter((loaded) => loaded),
      switchMap(() => this.authService.getUser()),
      tap((user) => {
        if (!user) {
          this.store.dispatch(SnackBarActions.show('Please login'));
        }
      }),
      map((user) => !!user || this.router.createUrlTree([PATH_FOR['LOGIN']]))
    );
  }
}
